/* eslint camelcase: 0 */

import { User as Data } from '@/typings/api/User'
import { Model, createMessages } from '@/helpers/Model'


export const USER_ACTIVE_OPTIONS = {
  ACTIVE: { label: 'Активный', value: true },
  DISABLED: { label: 'Заблокирован', value: false },
}

export class UserModel extends Model<Data> {
  public static readonly page_title = createMessages({
    create: 'Добавить пользователя',
    edit: 'Редактировать пользователя',
    view: (data: UserModel) => 'Пользователь «{name}»'
      .replace('{name}', data?.name ?? '...'),
    list: 'Пользователи',
    profile: 'Профиль пользователя',
  });

  public static readonly modal_delete = createMessages({
    delete: (data: UserModel) => 'Удаление пользователя «{name}»'
      .replace('{name}', data?.name ?? '...'),
    delete_all: 'Удаление выбранных пользователей',
    delete_all_partly: 'Удаление части выбранных пользователей',
  });

  public static readonly response_success = createMessages({
    ...Model.response_success,
    delete_all_deny: 'Выбранных пользователей нельзя удалить',
    logout_session: 'Сессия удалена',
  });

  public static readonly response_error = createMessages({
    ...Model.response_error,
    user_status: (data: UserModel) => 'Ошибка запроса статуса пользователя «{name}»'
      .replace('{name}', data?.name ?? '...'),
    logout_session: 'Ошибка удаления сессии',
  });

  public static getName(data: Data) {
    return data?.full_name ?? '...'
  }

  public static getUserStatusLabel(data: Data) {
    return data.is_active
      ? USER_ACTIVE_OPTIONS.ACTIVE.label
      : USER_ACTIVE_OPTIONS.DISABLED.label
  }
}
